import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpHandlerService } from 'src/app/shared-resources/services/http-handler.service';
import { UrlMapService } from 'src/app/shared-resources/services/url-map.service';
import { nonLnFDetail } from '../models/core-service.model';
@Injectable({
  providedIn: 'root'
})

export class CoreService {
  selectedCoreServiceId: string= '';
  selectedStateId: any;
  selectedRegionId: any;
  lastSearchEmployee: any;
  stateList: any;
  regionList: any;
  officeList: any;
  manageDisplayStatus: boolean = false;
  updateDisplayButton$ = new Subject<any>();
  searchUpdate$ = new Subject<any>();
  formUpdated: boolean = false;
  dataChanged: boolean = false;
  changeFormStatus$ = new Subject<any>();
  constructor(
    private urlMapService: UrlMapService,
    private https: HttpHandlerService,
    private httpClient: HttpClient
  ) {
    // blank constructor
}


  /** save non employee information */
  saveNonEmployee(obj:any) {
    const url = this.urlMapService.saveNonEmployeeUrl();
    return this.https.post(url, obj);
  } 

  /** save non employee information */
  updateNonEmployee(obj:any) {
    const url = this.urlMapService.saveNonEmployeeUrl();
    return this.https.put(url, obj);
  } 
  

  /** get URL list and check for URL*/
  getEmployeeBasedOnCoreService() {    
    const param = `CoreServiceId=${this.selectedCoreServiceId}`
    const url = this.urlMapService.getEmployeelistBasedOnCoreService() + param;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }


  /** set selected Service Id */
  setSelectedCoreServiceId(id: string) {
    this.selectedCoreServiceId = id;
  }

  /** set selected state Id */
  setSelectedStateId(id: string) {
    this.selectedStateId = id;
  }

  /** set selected region Id */
  setSelectedCoreRegionId(id: string) {
    this.selectedRegionId = id;
  }

  /**set last search Employee */
  setLastSearchEmployee(details: any) {
    this.lastSearchEmployee = details;
  }

  /** get last search employee */
  getLastSearchEmployee() {
    return this.lastSearchEmployee;
  }

    /**set data changed Flag */
    setDataChangeFlag(flag: boolean) {
      this.dataChanged = flag;
    }
  
    /** get data changed Flag */
    getDataChangeFlag() {
      return this.dataChanged;
    }

  /** get sales assignment list */
  getSalesAssignments(CoreServiceId: any, employeenumber: any) {
    const param = `${CoreServiceId}/sales-office-associations?employeeNumber=${employeenumber}`
    const url = this.urlMapService.getSalesAssignmentsUrl() + param;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** get current assignment list */
  getCurrentAssignments(searchDetails: any) {
    const params =  this.bindCurrentAssignmentParams(searchDetails);
    const url = this.urlMapService.getSalesAssignmentsUrl() + 'employee-current-associations?' + params;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** bind url params to get current offices */
  bindCurrentAssignmentParams(searchData: any) {
    let url = '';
    if(searchData && searchData.coreServiceId) {
      url = `coreServiceId=${searchData.coreServiceId}`
    }
  if(searchData && searchData.stateId) {
    if(url.includes('coreServiceId')) {
      url = url + `&stateId=${searchData.stateId}`
    } else {
      url = url + `stateId=${searchData.stateId}`;
    }
  } 
  if(searchData && searchData.regionName ) {
    if(url.includes('stateId') || url.includes('coreServiceId')) {
      url = url + `&regionName=${searchData.regionName}`;
    } else {
      url = url + `regionName=${searchData.regionName}`
    }
  }
  if(searchData && searchData.pcNumber) {
    if(url.includes('stateId') || url.includes('coreServiceId') || url.includes('regionName')) {
      url = url + `&pcNumber=${searchData.pcNumber}`;
    } else {
      url = url + `pcNumber=${searchData.pcNumber}`
    }
  }
  return url;
  }

  /** set state list */
  setStatelist(list: any) {
    this.stateList = list; 
  }

  /** set region list */
  setRegionlist(list: any) {
    this.regionList = list; 
  }

  /** set state list */
  setOfficelist(list: any) {
    this.officeList = list; 
  }

  /** get state list */
  getStateList() {
    return this.stateList;
  }

  /** get region list */
  getRegionList() {
    return this.regionList;
  }

  /** get office list */
  getOfficeList() {
    return this.officeList;
  }


  /** get sales assignment list */
  getSalesOffices(formValues: any, employeeId: any) {
    const params =  this.bindParams(formValues, employeeId);
    const url = this.urlMapService.getSalesAssignmentsUrl() + 'sales-offices?' + params;
    const opts = { observe: 'response' };
    return this.https.get(url, opts);
  }

  /** bind url params to get sales offices */
  bindParams(formValues: any, employeeDetails: any) {
    let url = '';
    if(formValues.state !== '') {
      url = `stateId=${formValues.state}`;
    } 
    if(formValues.pcnumber || formValues.officeName) {
      if(url.includes('stateId')) {
        url = url + `&pcNumber=${formValues.pcnumber?.id ?? formValues.pcnumber}`;
      } else {
        url = url + `pcNumber=${formValues.pcnumber?.id ?? formValues.pcnumber}`
      }
    }
    if(formValues.region !== "") {
      if(url.includes('stateId') || url.includes('pcNumber')) {
        url = url + `&regionName=${formValues.region}`;
      } else {
        url = url + `regionName=${formValues.region}`
      }
    }
    if(employeeDetails !== '') {
      if(url.includes('stateId') || url.includes('pcNumber') || url.includes('regionName')) {
        url = url + `&emloyeeNumber=${employeeDetails}`;
      } else {
        url = url + `emloyeeNumber=${employeeDetails}`
      }
    }
    return url;
  }

  /**create associations*/
  createAssociations(obj: any) {
    const url = this.urlMapService.getSalesAssignmentsUrl() + 'sales-offices/employee-association';
    return this.https.post(url, obj);    
  }


  /** get Manage display options */
  getManageDisplay(id: any) {
    const url = this.urlMapService.getSalesAssignmentsUrl() + 'employee-associations/hide-display-option?employeeNumber=' + id;
    return this.https.get(url); 
  }

  /** save updated sales assignment */
  saveUpdatedSalesAssignment(obj: any) {
    const url = this.urlMapService.getSalesAssignmentsUrl() + 'sales-offices/employee-association';
    return this.https.put(url, obj);
  }

  /** save updated sales assignment */
  deletSalesAssignment(obj: any) {
    const url = this.urlMapService.getSalesAssignmentsUrl() + 'sales-offices/employee-associations';
    return this.https.delete(url, {body: obj});
  }


  /** set manage display status */
  setManageDisplayStatus(flag: boolean) {
    this.manageDisplayStatus = flag;
  }

  /** get manage display status */
  getManageDisplayStatus() {
    return this.manageDisplayStatus;
  }


  saveManageDisplay(employeeNumber: number, flag: boolean) {
    const url = this.urlMapService.getSalesAssignmentsUrl() + `employee-associations/manage-hide-display?employeeNumber=${employeeNumber}&hideDisplay=${flag}`; 
    return this.https.post(url);
  }

  public subscribeUpdateDisableButton(callback: (user: any) => void): Subscription {
    return this.updateDisplayButton$.subscribe(callback);
  }

  setFormUpdateStatus(flag: boolean) {
    this.changeFormStatus$.next(flag);
    this.formUpdated = flag;
  }

  getFormUpdatedStatus() {
    return this.formUpdated;
  }

  public subscribeUpdateUpdateCurrentSearch(callback: (user: any) => void): Subscription {
    return this.searchUpdate$.subscribe(callback);
  }

  public subscribeCheckFormUpdate(callback: (user: any) => void): Subscription {
    return this.changeFormStatus$.subscribe(callback);
  }

  /** get nonLnF details api method */
  getNonLnFDetail(agentNumber: number): Observable<nonLnFDetail> {
    const url = this.urlMapService.getNonLnFDetail() + agentNumber;
    return this.httpClient.get<nonLnFDetail>(url);
  }
  
}
